/**
 * 科大讯飞定制需求，用户体验反馈SDK
 */
export const initXunfeiFeedbackSDK = () => {
  const user = $ZConfig.getVal('userInfo')
  if (user && user.partnerId) {
    if ([4749, 4796, 59, 1518].includes(user.partnerId)) {
      if (!window.newFeedbackSDK) {
        const userId = user.empCode
        const userName = user.name
        $tool.loadScript('https://in.iflytek.com/static/js-sdk-feedback-v1.0-min.js', () => {
          var count = 0
          var time = null
          time = setInterval(() => {
            count++
            if (count >= 5) {
              clearInterval(time)
            }
            // 使用try catch不影响业务正常使用
            try {
              if (FeedbackSDK) {
                var newFeedbackSDK = new FeedbackSDK({
                  userId: userId, // 必传
                  userName: userName, // 必传
                  systemSource: '科大讯飞差旅', // 必传，系统来源
                  debug: false // 必传，true 测试环境，false 生产环境
                })
                window.newFeedbackSDK = newFeedbackSDK
                clearInterval(time)
              }
            } catch (e) {
              console.log('=== FeedbackSDK 实例化失败，请检查引入地址是否正确 ===')
            }
          }, 500)
        })
      }
    }
  }
}
